import { usePageHeader } from '@hooks/useHeader.ts'
import { useIsWideLayout } from '@hooks/useMediaQuery.ts'
import useTypedTranslation from '@hooks/useTypedTranslation'
import AccountRouteDesktop from '@routes/Account/AccountRouteDesktop'
import AccountRouteMobile from '@routes/Account/AccountRouteMobile'

function AccountRoute() {
  const { t } = useTypedTranslation()
  usePageHeader({ title: t('account.title'), showQuickSelection: false })
  const isWideLayout = useIsWideLayout()
  return isWideLayout ? <AccountRouteDesktop /> : <AccountRouteMobile />
}

export default AccountRoute